<!--
트래킹검수 > 검수화면 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-padding-xsmall" >
        <!-- 검수대상 리스트-->
        <component
            v-bind:is="checkMode"
            class="uk-margin-bottom"
            :csrf-token="csrfToken"
            :login-user-id="loginUserId"
            :region-id="regionId"
            :check-prods="checkProds"
            :house-groups="houseGroups"
            :active-house-group-id="activeHouseGroupId"
            :expensive-limit="expensiveLimit"

            @check:exception="msg => listneCheckException(msg)"
            @check:one="listneCheckOne"
            @packing="house_id => listnePacking(house_id)"
        >

        </component>

        <!-- 검수 완료 메세지 -->
        <div
            class="uk-margin-large-bottom uk-text-center uk-text-large"
            v-if="checkProds.length === 0"
        >

            <!-- 무자료버튼 -->
            <div class="button-reg-nodata" @click="$parent.showNodataPart(trackingNo, userId)">
                남아있는 상품이 있다면, 무자료 등록하세요.
                <div class="name">(부분) 무자료 등록하기 (CLICK)</div>

            </div>

            <div>
                <i class="material-icons font-size-3rem">
                    check_circle
                </i>
                모든 상품의 검수가 완료되었습니다


            </div>

            <div class="uk-margin-top">
                <button
                    class="uk-button uk-button-primary uk-button-large2"
                    @click="$parent.showScan"
                >
                    <i class="material-icons">
                        aspect_ratio
                    </i>
                    SCAN (NEXT BOX)
                </button>
            </div>




        </div>

        <!-- 검수완료 리스트 -->
        <other-prods
            :csrf-token="csrfToken"
            :region-id="regionId"
            :other-prods="otherProds"
            @packing="house_id => listnePacking(house_id)"
        >

        </other-prods>
    </div>
</template>

<script>
    export default {
        components: {
            'oldNormal': require('./check-prods/normal.vue').default,
            'normal': require('./check-prods/normal-2405/main.vue').default,
            'batch': require('./check-prods/batch/main.vue').default,
            'new': require('./check-prods/new/main.vue').default,
            'other-prods': require('./other-prods.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 검수모드
             */
            checkMode: {
                type: String,
            },

            /**
             * 스캔 번호
             */
            /*
            scanNo: {
                type: String,
            },
            */

            /**
             * 고가상품 기준가격(현지 currency)
             **/
            expensiveLimit: {
              type: Number,
              default: 200,
            },
        },
        data: function () {
            return {
                // 선택된 트래킹번호
                trackingNo: null,

                // 선택된 사용자ID
                userId: null,

                // 스캔된 번호
                scannedNo: null,

                /**
                 * (array) 검수대상 상품리스트
                 * [
                 *      {상품 object},
                 * ]
                 */
                checkProds: [],

                /**
                 * (array) 검수대상 하우스 그룹
                 *  - 일괄검수에서 사용할 리스트
                 *
                 * [
                 *      {하우스정보 object},
                 * ]
                 */
                houseGroups: [],

                /**
                 * (array) 검수대상 외 상품리스트
                 * [
                 *      {상품 object},
                 * ]
                 */
                otherProds: [],

            };
        },
        computed: {
            /**
             * (일괄검수모드 에서 사용)
             * 현재 체크박스가 선택된 하우스ID
             */
            activeHouseGroupId() {
                let active = _.find(this.houseGroups, (houseGroup) => {

                    let has_checked = _.find(houseGroup.batch.items, (item) => {
                        return item.checked;
                    });
                    return !! has_checked;
                });

                if (active) {
                    return active.id;
                } else {
                    return null;
                }
            },

        },

        methods: {
            /**
             * 선택한 트래킹의 상품들을 조회
             * @param tracking_no
             * @param user_id
             * @param callback (function) 조회 후 실행될 함수
             * @param scanned_no
             */
            loadProds: function (tracking_no, user_id, callback, scanned_no) {
                // 선택정보 저장
                this.trackingNo = tracking_no;
                this.userId = user_id;
                this.scannedNo = scanned_no;

                /**
                 * 상품 조회
                 */
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/' + this.regionId + '/tracking-check-prods',
                        contentType: 'application/json',
                        data: {
                            tracking_no,
                            user_id,
                            scanned_no,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.checkProds = response.check_prods;
                    this.otherProds = response.other_prods;

                    // 일괄검수용 하우스그룹 작성
                    this.makeHouseGroup();

                    // 콜백 실행
                    if (callback) {
                        callback();
                    }
                });
            },

            /**
             * 일괄검수용 하우스 그룹 작성
             */
            makeHouseGroup: function () {

                // 상품에 일괄 체크박스를 위한 정보추가
                _.each(this.checkProds, function (prod) {
                    // 보류요청있는 경우는 체크박스 작성안함
                    if (prod.lock_hold_req) {
                        prod.checkbox = null;
                        return;
                    }

                    // 이미 체크박스 작성됨
                    if (prod.checkbox) {
                        return;
                    }

                    prod.checkbox = {
                        id: prod.id,
                        checked: false,
                        amount: prod.amount,
                    };
                });

                // 하우스 그룹 작성
                let prod_index_in_tracking = 1;
                let prod_total_count_in_tracking = this.checkProds.length;
                this.houseGroups = _.chain(this.checkProds)
                    .groupBy('house_code')
                    .map((value, key) => {
                        // (트래킹 내 상품 인덱스 계산을 위한) 첫번째 하우스상품의 인덱스 시작값
                        let first_prod_index_in_tracking = prod_index_in_tracking;
                        prod_index_in_tracking += value.length;

                        let first = value[0];
                        return {
                            code: key,
                            id: first.house_id,
                            name: first.h_name,
                            total_amount: _.sumBy(value, 'amount'),
                            prods: value,

                            prod_total_count_in_tracking: prod_total_count_in_tracking,
                            first_prod_index_in_tracking: first_prod_index_in_tracking,

                            pack_type: first.h_pack_type,
                            safety_pack_type: first.h_safety_pack_type,
                            pack_request: first.h_pack_request,
                            pack_type_text: first.h_pack_type_text,
                            safety_pack_type_text: first.h_safety_pack_type_text,



                            // 일괄작업 정보
                            batch: {
                                items: _.map(_.filter(value, 'checkbox'), 'checkbox'),
                                checked_item_count: 0,
                            },
                        };
                    })
                    .value();
            },


            /**
             * 상품들을 다시 조회
             * @param callback (function) 조회 후 실행될 함수
             */
            reload: function (callback) {
                this.loadProds(this.trackingNo, this.userId, callback, this.scannedNo);
            },


            /**
             * 검수중 예외가 발생했을때의 리스너
             */
            listneCheckException: function (msg) {
                this.reload(() => {
                    // 오류 얼럿
                    var labels = {
                        ok: 'Ok',
                        cancel: 'Cancel'
                    };
                    var options = {bgClose: false, escClose: false, labels: labels};
                    UIkit.modal.dialog(
                        '<div class="uk-modal-body uk-text-large3">'+ msg +'</div>'+
                        '<div class="uk-modal-footer uk-text-right">'+
                        '<button class="uk-button uk-button-danger uk-button-large uk-modal-close" autofocus>확인</button>'+
                        '</div>'
                        , options);
                });
            },

            /**
             * 상품한개의 검수가 끝났을때의 이벤트 리스너
             */
            listneCheckOne: function () {
                this.reload(() => {
                    if (this.checkProds.length > 0) {
                        // 다음 상품검수 안내
                        UIkit.notification({
                            message: '<div class="uk-text-large3 app-color-black">계속 검수하세요</div>',
                            status: 'primary',
                            //timeout: 10000,
                        });
                    }
                });
            },

            /**
             * 상품을 패킹해야될때의 이벤트 리스너
             */
            listnePacking: function (house_id) {
                //console.log('패킹 : ' + house_id)
                this.$parent.showPacking(house_id);

                // 패킹작업에 대한 알림
                UIkit.notification({
                    message: '<div class="uk-text-large app-color-black">패킹하세요</div>',
                    status: 'primary',
                    //timeout: 10000,
                });
            },


        },
    }
</script>

<style lang="scss" scoped>
.button-reg-nodata {
    display: inline-block;
    padding: 0.5rem 3rem;
    font-size: 1rem;

    background-color: #ffffbc;
    border: 1px solid #666;
    color: #000;

    .name {
        margin-top: 0.5rem;
        font-size: 1.25rem;
        font-weight: bold;
    }

    margin-bottom: 4rem;

    cursor: pointer;
}
</style>